export const groupUsageProgressIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Group Summary Report is where you can view an overview of all student information. You can see student usage, progress, and engagement data.'
  },
  {
    element: '.filter-options',
    intro: 'Use these filters to narrow down the students by grade, class, Extra Support setting, or Zone.'
  },
  {
    element: '.district-report-header-group',
    intro: 'The Usage and Progress page automatically opens when you open the Group Summary report. The Usage and Progress page includes the current placement, zone, progress as a percentage, and weekly minutes. Click on Engagement to see student engagement data. The Engagement page includes points, team data, and level completion. '
  },
  {
    element: '#show-teacher-wrapper',
    intro: 'Select this checkbox to show the teacher column in this report.'
  },
  {
    element: '#show-shared-wrapper',
    intro: 'Select this box to hide students who have been shared with you. Once enabled, the student list below will only display those you are directly assigned to — excluding any students you\'re listed as a co-teacher for.'
  },
  {
    element: 'refresh-button',
    intro: 'Click here to refresh the Group Summary data.'
  },
  {
    element: '#export-button',
    intro: 'Click here to export the report data for analysis and sharing.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Group Summary report.'
  },
  {
    element: 'table.report-table thead',
    intro: 'Click on any column header to sort the column.'
  },
  {
    element: 'table.report-table th:nth-child(1)',
    intro: 'See each student’s name. Click on the column header to sort the students alphabetically by last name.'
  },
  {
    element: 'table.report-table th:nth-child(2)',
    intro: 'See each student’s grade. Click on the column header to sort by grade.'
  },
  {
    element: 'table.report-table th:nth-child(3)',
    intro: 'See when each student started in the WordFlight system.'
  },
  {
    element: 'table.report-table th:nth-child(4)',
    intro: 'See when each student last logged into WordFlight.'
  },
  {
    element: 'table.report-table th:nth-child(5)',
    intro: 'See each student\'s current placement in the online student program (Unit 1-24, Pre, Mid, or Post Diagnostic). This information is needed for teacher-facilitated small groups.'
  },
  {
    element: 'table.report-table th:nth-child(6)',
    intro: 'See each student’s progress through the WordFlight curriculum.'
  },
  {
    element: 'table.report-table th:nth-child(7)',
    intro: 'See each student’s current instructional zone (Zones 1-4). Students are sorted into one of four instructional zones following each Diagnostic (Pre-, Mid-, and Post-). This information is needed for teacher-facilitated small groups. Group students by zone.'
  },
  {
    element: 'table.report-table th:nth-child(8)',
    intro: 'See each student’s average weekly usage minutes. The goal is for this average to be 60-80 minutes.'
  },
  {
    element: 'table.report-table th:nth-child(9)',
    intro: 'See each student’s usage minutes for the previous week. The goal is for this usage to be 60-80 minutes. Colors and symbols show which student met the previous week goal.'
  },
  {
    element: 'table.report-table th:nth-child(10)',
    intro: 'See each student’s usage minutes for the current week. The goal is for this usage to reach 60-80 minutes by the end of the week. Check this column halfway through the week to make sure students will meet their goals.'
  }
];
